import React, { useEffect, useRef, useState } from "react";
import styles from "./Page3.module.scss";

import getstarted from "../../../Components copy/assets/Images/getstarted.svg";
import hoverImage1 from "../../../Components copy/assets/Images/hoverimage1.svg";
import hoverImage2 from "../../../Components copy/assets/Images/hoverimage2.svg";
import hoverImage3 from "../../../Components copy/assets/Images/hoverimage3.svg";
import hoverImage4 from "../../../Components copy/assets/Images/hoverimage4.svg";
import hoverImage5 from "../../../Components copy/assets/Images/hoverimage5.svg";
import hoverImagemain1 from "../../../Components copy/assets/Images/hoverimagemain1.svg";
import hoverImagemain2 from "../../../Components copy/assets/Images/hoverimagemain2.svg";
import hoverImagemain3 from "../../../Components copy/assets/Images/hoverimagemain3.svg";
import buildingimage from "../../../Components copy/assets/Images/buildingimage.svg";
import { Button } from "@mui/material";
import startedarrow from "../../../Components copy/assets/Images/startArrow.svg";
import support from "../../../Components copy/assets/Images/headphones.svg";
import { useNavigate } from "react-router-dom";

const cardDataFirst = [
  {
    image: hoverImagemain1,
    title: "EQUITY",
    heading: "Empowering Wealth Growth: Embrace the Potential of Equities",
    des: "Unlock Opportunities for Prosperity with Equities. Make clients to Navigate the Markets with Confidence.",
    navLink: "https://login.thefirstock.com/#/",
  },
  {
    image: hoverImagemain2,
    title: "F&O",
    heading: "Strategic Futures & Options: Amplifying Your Investment Edge.",
    des: "Maximize Returns, Minimize Risks: Embrace the Power of Futures & Options Trading for clients.",
    navLink: "https://login.thefirstock.com/#/",
  },
  {
    image: hoverImagemain3,
    title: "INTRADAY",
    heading: "Mastering Intraday Excellence: Elevate Your Trading Experience.",
    des: "Explore the Dynamic World of Intraday Trading. Harness Strategic Insights, Optimize Returns for clients.",
    navLink: "https://login.thefirstock.com/#/",
  },
];
const cardData1 = [
  {
    image: hoverImage1,
    title: "MUTUAL FUNDS",
    heading: "Choose Wealth Preservation: Embrace the Sovereign Gold Bond.",
    des: "Uncover the Precious Clients Potential of Sovereign Gold Bonds for Secure Wealth Preservation.",
    navLink: "https://investments.thefirstock.com/",
  },
  {
    image: hoverImage2,
    title: "CORPORATE BONDS",
    heading: "Choice of High quality Corporate Bonds.",
    des: "Optimize Your Clients' Capital by Engaging in Corporate Bonds before Market Recognition.",
    navLink: "https://investments.thefirstock.com/",
  },
  {
    image: hoverImage3,
    title: "GOVERNMENT BONDS",
    heading: "Unlocking Stability and Growth: with Government Bonds.",
    des: "Tailored Solutions for Discerning Partners, Delivering Robust Returns in a Low-Risk Environment.",
    navLink: "https://investments.thefirstock.com/",
  },
];
const cardData2 = [
  {
    image: hoverImage4,
    title: "SOVEREIGN GOLD BOND",
    heading: "Choose Wealth Preservation: Embrace the Sovereign Gold Bond.",
    des: "Uncover the Precious Clients Potential of Sovereign Gold Bonds for Secure Wealth Preservation.",
    navLink: "https://investments.thefirstock.com/",
  },
  {
    image: hoverImage5,
    title: "IPOs",
    heading: "Seize the chance to invest in shares prior to the IPO.",
    des: "Strategically allocate your clients' capital to stocks before they capture the market's attention.",
    navLink: "https://investments.thefirstock.com/",
  },
];

export default function Page3() {
  const navigate = useNavigate();
  return (
    <div className={styles.mainWrapper}>
      <div className={styles.topSection}>
        <p className={styles.headingText1}>Investment Products On</p>
        <p className={styles.headingText}>Firstock Partners</p>
      </div>
      <div className={styles.hoverCardsSection}>
        {cardDataFirst.map((a: any, index: any) => (
          <div className={styles.hoverContent}>
            <div className={styles.imagesection}>
              <img
                src={a.image}
                className={styles.hoverimage}
                style={{
                  width:
                    index === 1 ? "200px" : index === 2 ? "280px" : "300px",
                }}
              />
            </div>
            <div className={styles.centerimagetextScetion}>
              <img src={buildingimage} className={styles.buildingimage} />
              <p className={styles.buildingimagetext}>{a.title}</p>
            </div>
            <div className={styles.bottomsection}>
              <p className={styles.bottomsectiontext1}>{a.heading}</p>
              <p className={styles.bottomsectiontext2}>{a.des}</p>
            </div>
            <div className={styles.hiddenSection}>
              <img
                src={getstarted}
                className={styles.getstartedimage}
                onClick={() => {
                  window.open(`${a.navLink}`, "_blank");
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.hoverCardsSection}>
        {cardData1.map((a: any, index: any) => (
          <div className={styles.hoverContent}>
            <div className={styles.imagesection}>
              <img
                src={a.image}
                className={styles.hoverimage}
                style={{
                  marginBottom: index === 1 ? "30px" : "none",
                }}
              />
            </div>
            <div className={styles.centerimagetextScetion}>
              <img src={buildingimage} className={styles.buildingimage} />
              <p className={styles.buildingimagetext}>{a.title}</p>
            </div>
            <div className={styles.bottomsection}>
              <p className={styles.bottomsectiontext1}>{a.heading}</p>
              <p className={styles.bottomsectiontext2}>{a.des}</p>
            </div>
            <div className={styles.hiddenSection}>
              <img
                src={getstarted}
                className={styles.getstartedimage}
                onClick={() => {
                  window.open(`${a.navLink}`, "_blank");
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.hoverCardsSection2}>
        {cardData2.map((a: any) => (
          <div className={styles.hoverContent}>
            <div className={styles.imagesection}>
              <img src={a.image} className={styles.hoverimage} />
            </div>
            <div className={styles.centerimagetextScetion}>
              <img src={buildingimage} className={styles.buildingimage} />
              <p className={styles.buildingimagetext}>{a.title}</p>
            </div>
            <div className={styles.bottomsection}>
              <p className={styles.bottomsectiontext1}>{a.heading}</p>
              <p className={styles.bottomsectiontext2}>{a.des}</p>
            </div>
            <div className={styles.hiddenSection}>
              <img
                src={getstarted}
                className={styles.getstartedimage}
                onClick={() => {
                  window.open(`${a.navLink}`, "_blank");
                }}
              />
            </div>
          </div>
        ))}
      </div>
      <div className={styles.bottomSection}>
        <div className={styles.topSection}>
          <p className={styles.headingText1}>
            Unlock Limitless Possibilities with{" "}
          </p>
          <p className={styles.headingText1}>Our Firstock Partners</p>
          <div className={styles.bottomSectionButtons}>
            <div>
              <Button
                endIcon={<img src={startedarrow} />}
                sx={{
                  background: "#006779",
                  color: "white",
                  fontSize: "14px",
                  borderRadius: "10px",
                  padding: "3px 20px",
                  "&:hover": {
                    background: "#006779",
                    color: "white",
                  },
                }}
                onClick={() => {
                  navigate("/login");
                }}
              >
                Get started
              </Button>
            </div>
            <div>
              <Button
                endIcon={<img src={support} />}
                sx={{
                  background: "#EEEFEF",
                  color: "#5A6475",
                  fontSize: "14px",
                  borderRadius: "10px",
                  padding: "3px 20px",
                  "&:hover": {
                    background: "#EEEFEF",
                    color: "#5A6475",
                  },
                }}
                onClick={() => {
                  window.open("https://thefirstock.com/contact.html", "_blank");
                }}
              >
                Customer support
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
